import { useApiQuery } from '../use-api.js';
import { VerdictPill } from '../components/VerdictPill.js';
import type { CoverageResponse } from '../lib/types.js';

export function Coverage() {
  const query = useApiQuery<CoverageResponse>(['coverage'], '/api/test-env-coverage');

  if (query.isLoading) return <p>Loading coverage…</p>;
  if (query.isError || !query.data) return <p className="error">Failed to load coverage.</p>;

  const { repos, counts } = query.data;
  const countEntries = Object.entries(counts ?? {});

  return (
    <section>
      <h2>Test-env coverage</h2>

      <div className="counts">
        {countEntries.length === 0 && <span className="empty">No counts.</span>}
        {countEntries.map(([verdict, n]) => (
          <span key={verdict} className="count-chip">
            <VerdictPill verdict={verdict} /> <strong>{n}</strong>
          </span>
        ))}
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>Repo</th>
            <th>Verdict</th>
            <th>Last run</th>
          </tr>
        </thead>
        <tbody>
          {(repos ?? []).length === 0 && (
            <tr><td colSpan={3} className="empty">No repos.</td></tr>
          )}
          {(repos ?? []).map((r) => (
            <tr key={r.repo}>
              <td>{r.repo}</td>
              <td><VerdictPill verdict={r.verdict} /></td>
              <td>{r.created_at ? r.created_at.slice(0, 16) : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
